<template>
  <b-container fluid>
    <backlink />
    <h1>L'équipe</h1>

    <AdminTable :config="config"></AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTable";
import config from "./config";

export default {
  name: "TheTeamList",
  components: {
    AdminTable,
  },
  data() {
    return {
      config: config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TheTeam/TheTeamList.vue